module.exports = __webpack_public_path__ + "static/media/data-not-available.efdff9d3.png";